module.exports = __webpack_public_path__ + "static/img/tx.8d2742b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/tx.png
// module id = lCk7
// module chunks = 1